import mixitup from "mixitup";
import { registerBundle } from "scripts/lib/register-bundle.js";
if (typeof window !== "undefined") window.mixitup = mixitup;
registerBundle("vendors@template.blog");
